import { useState } from "react";
import { motion } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Amelia R.",
    piece: "Solitaire Aurora, 1.5 ct",
    text: "The most breathtaking piece I've ever owned. The certificate, the packaging. every detail felt considered. My fiancé's face when he saw it live-priced in silver, then upgraded to 18K, was worth every dollar.",
    location: "Toronto",
  },
  {
    name: "Priya S.",
    piece: "Whisper Halo Studs",
    text: "I compared them against three well-known brands. Dreamonds beat the price by 18%, delivered in seven days, and the diamonds are visibly more brilliant. The customer team walked me through carat sizing personally.",
    location: "Vancouver",
  },
  {
    name: "Marcus L.",
    piece: "Custom Signet",
    text: "I sent them a rough sketch and they turned it into a signet ring I wear every day. The consultation calendar made booking trivial and the atelier delivered ahead of schedule.",
    location: "Montréal",
  },
  {
    name: "Ivy C.",
    piece: "Baguette Eternity Band",
    text: "Ethically grown, IGI certified, and priced in CAD. no exchange-rate surprises at checkout. My band pairs perfectly with a ring I've owned for years.",
    location: "Calgary",
  },
];

export const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const cur = REVIEWS[idx];

  return (
    <section data-testid="testimonials-section" className="bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-28">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-4">
            <p className="label-track text-[#C8A165] mb-4">Kind Words</p>
            <h2 className="font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#0A0A0A] leading-[1.05]">
              Loved by <br /><span className="italic text-[#C8A165]">real people.</span>
            </h2>
            <div className="mt-8 flex items-center gap-1 text-[#C8A165]">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={16} fill="currentColor" strokeWidth={0} />
              ))}
              <span className="ml-3 text-[#525252] text-sm font-mono">4.9 · 1,200+ reviews</span>
            </div>
          </div>

          <div className="md:col-span-8">
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              data-testid="testimonial-quote"
              className="relative p-10 md:p-14 border border-[#EFE7D8] bg-[#FAF7F1]"
            >
              <Quote size={38} className="text-[#C8A165] mb-6" strokeWidth={1.2} />
              <p className="font-heading text-2xl md:text-3xl text-[#0A0A0A] leading-[1.35] italic">
                "{cur.text}"
              </p>
              <div className="mt-8 flex items-center justify-between">
                <div>
                  <div className="label-track text-[#0A0A0A]">{cur.name}</div>
                  <div className="text-[#737373] text-xs mt-1 font-mono">
                    {cur.piece} · {cur.location}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    data-testid="testimonial-prev"
                    onClick={() => setIdx((i) => (i - 1 + REVIEWS.length) % REVIEWS.length)}
                    className="w-10 h-10 flex items-center justify-center border border-[#E5E5E5] hover:border-[#0A0A0A] hover:text-[#C8A165] transition-all"
                    aria-label="Previous review"
                  >
                    <ChevronLeft size={16} />
                  </button>
                  <button
                    data-testid="testimonial-next"
                    onClick={() => setIdx((i) => (i + 1) % REVIEWS.length)}
                    className="w-10 h-10 flex items-center justify-center border border-[#E5E5E5] hover:border-[#0A0A0A] hover:text-[#C8A165] transition-all"
                    aria-label="Next review"
                  >
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            </motion.div>
            <div className="flex gap-1.5 mt-5 justify-end">
              {REVIEWS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  className={`h-1 transition-all duration-300 ${i === idx ? "w-8 bg-[#C8A165]" : "w-4 bg-[#E5E5E5]"}`}
                  data-testid={`testimonial-dot-${i}`}
                  aria-label={`Review ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
